export default function () {
  return [
    { value: 'E', text: 'Ativo' },
    { value: 'D', text: 'Desistente' },
    { value: 'B', text: 'Bloqueado' },
    { value: 'C', text: 'Cancelado' },
    { value: 'F', text: 'Finalizado' }
  ]
}
